import _ from "lodash";
import {useCallback, useContext} from "react";
import {UserContext} from "../contexts";
import {ONBOARDING_TASKS} from "../constants/constants";

export default function useOnboardingUser() {
  const { onboardingUser: user } = useContext(UserContext);

  const isOnboardingTaskCompleted = useCallback((task) => {
    if (!user) return false;
    const {
      liveScanCompleted,
      waiverCompleted,
      workbookForm1Completed,
      workbookForm2Completed,
      workbookForm3Completed,
      workbookFormReviewCompleted,
      workbookAvailabilityModuleCompleted
    } = user;

    switch (task) {
      // case ONBOARDING_TASKS.CHAT: {
      //     const completedStatuses = [
      //       "Application Accepted",
      //       "Matched",
      //       "Ready to Tutor",
      //       "Workstudy - Pending",
      //     ];
        
      //     const isInterviewCompleted =
      //       completedStatuses.includes(status) || !!user.acceptedDate;

      //     if (isInterviewCompleted) return true;
        
      //     const now = new Date().toISOString();
      //     const isInterviewPending = user.interviewDate && new Date(user.interviewDate).toISOString() >= now;
        
      //     if (isInterviewPending) return false;
        
      //     return false;
      // }
      case ONBOARDING_TASKS.WAIVER:
        return waiverCompleted;
      case ONBOARDING_TASKS.WORKBOOK:
        return _.every([
          workbookForm1Completed,
          workbookForm2Completed,
          workbookForm3Completed,
          workbookFormReviewCompleted,
          workbookAvailabilityModuleCompleted
        ]);
      case ONBOARDING_TASKS.BACKGROUND_CHECK:
        return liveScanCompleted;
      default:
        return null;
    }
  },
  [user],
  );
  return { user, isOnboardingTaskCompleted };
}
